{
  "integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.confluence-app": [
    {
      "type": 0,
      "value": "Get Confluence notifications on your phone! Download the Confluence Cloud app for "
    },
    {
      "type": 1,
      "value": "androidLink"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "type": 1,
      "value": "iosLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.feedback": [
    {
      "type": 0,
      "value": "Give feedback"
    }
  ],
  "integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.jira-app": [
    {
      "type": 0,
      "value": "Get Jira notifications on your phone! Download the Jira Cloud app for "
    },
    {
      "type": 1,
      "value": "androidLink"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "type": 1,
      "value": "iosLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.privacy": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "integrations-service.integrations-service-mcp-request-notification.message-template.in-app.admin-hub-notifications.heading.no-translate": [
    {
      "type": 0,
      "value": "MCP server request for "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "integrations-service.integrations-service-mcp-request-notification.message-template.notification-drawer.message.no-translate": [
    {
      "type": 0,
      "value": "MCP server request for "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.confluence-app": [
    {
      "type": 0,
      "value": "Get Confluence notifications on your phone! Download the Confluence Cloud app for "
    },
    {
      "type": 1,
      "value": "androidLink"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "type": 1,
      "value": "iosLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.feedback": [
    {
      "type": 0,
      "value": "Give feedback"
    }
  ],
  "integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.jira-app": [
    {
      "type": 0,
      "value": "Get Jira notifications on your phone! Download the Jira Cloud app for "
    },
    {
      "type": 1,
      "value": "androidLink"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "type": 1,
      "value": "iosLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.privacy": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "integrations-service.mcp-server-request-digest.message-template.email.footer.confluence-app": [
    {
      "type": 0,
      "value": "Get Confluence notifications on your phone! Download the Confluence Cloud app for Android or iOS."
    }
  ],
  "integrations-service.mcp-server-request-digest.message-template.email.footer.feedback": [
    {
      "type": 0,
      "value": "Give feedback"
    }
  ],
  "integrations-service.mcp-server-request-digest.message-template.email.footer.jira-app": [
    {
      "type": 0,
      "value": "Get Jira notifications on your phone! Download the Jira Cloud app for Android or iOS."
    }
  ],
  "integrations-service.mcp-server-request-digest.message-template.email.footer.privacy": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.after.blank-page": [
    {
      "type": 0,
      "value": "A shared consent link may display a blank page after the Microsoft administrator selects "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Accept"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ". This is expected."
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.after.consequence": [
    {
      "type": 0,
      "value": "If consent isn't granted by "
    },
    {
      "type": 1,
      "value": "deadline"
    },
    {
      "type": 0,
      "value": ", users may no longer be able to resolve SharePoint and OneDrive Smart Links or find SharePoint and OneDrive content through Rovo."
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.after.heading": [
    {
      "type": 0,
      "value": "After granting consent"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.after.verify": [
    {
      "type": 0,
      "value": "To verify completion, the Microsoft administrator can open "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Enterprise applications"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " in the Microsoft Entra admin center, search for application ID "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "applicationId"
        }
      ],
      "type": 8,
      "value": "mono"
    },
    {
      "type": 0,
      "value": ", open the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Atlassian"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " application, and confirm under "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Permissions"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " that admin consent has been granted."
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.application.heading": [
    {
      "type": 0,
      "value": "Application to approve"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.application.id": [
    {
      "children": [
        {
          "type": 0,
          "value": "Application ID:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "applicationId"
        }
      ],
      "type": 8,
      "value": "mono"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.application.name": [
    {
      "children": [
        {
          "type": 0,
          "value": "Name:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Atlassian"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.application.publisher": [
    {
      "children": [
        {
          "type": 0,
          "value": "Verified publisher:"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " Atlassian"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.cta": [
    {
      "type": 0,
      "value": "Open the Microsoft admin consent flow"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.disruption.intro": [
    {
      "type": 0,
      "value": "Complete this by "
    },
    {
      "type": 1,
      "value": "deadline"
    },
    {
      "type": 0,
      "value": " to prevent disruption to:"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.disruption.previews": [
    {
      "type": 0,
      "value": "SharePoint and OneDrive rich-link and inline-file previews"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.disruption.rovo": [
    {
      "type": 0,
      "value": "SharePoint and OneDrive experiences in Rovo"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.heading": [
    {
      "type": 0,
      "value": "Keep SharePoint and OneDrive working in Atlassian"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.intro": [
    {
      "type": 0,
      "value": "A Microsoft 365 administrator needs to approve Atlassian's new Microsoft publisher-verified application for your Atlassian site, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "siteName"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.preheader": [
    {
      "type": 0,
      "value": "Ask your Microsoft 365 administrator to approve Atlassian's publisher-verified application."
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.application-administrator": [
    {
      "type": 0,
      "value": "Application Administrator"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.atlassian-account": [
    {
      "type": 0,
      "value": "The Microsoft administrator needs an Atlassian account to open the consent flow, but they don't need Atlassian admin permissions."
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.cloud-application-administrator": [
    {
      "type": 0,
      "value": "Cloud Application Administrator"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.forward": [
    {
      "type": 0,
      "value": "If you don't have one of these roles, forward this email or send the consent link to your Microsoft administrator."
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.global-administrator": [
    {
      "type": 0,
      "value": "Global Administrator"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.heading": [
    {
      "type": 0,
      "value": "Who should complete this?"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.intro": [
    {
      "type": 0,
      "value": "The person granting consent must have one of these Microsoft 365 roles:"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.subject": [
    {
      "type": 0,
      "value": "Action required by "
    },
    {
      "type": 1,
      "value": "deadline"
    },
    {
      "type": 0,
      "value": ": Keep SharePoint and OneDrive working in Atlassian"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.support-doc": [
    {
      "type": 0,
      "value": "For complete instructions, see "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Upgrade your SharePoint and OneDrive connection in Atlassian"
        }
      ],
      "type": 8,
      "value": "link"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.copied": [
    {
      "type": 0,
      "value": "Copied!"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.copy-consent-link": [
    {
      "type": 0,
      "value": "Copy consent link"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.description": [
    {
      "type": 0,
      "value": "Grant admin consent to the updated SharePoint app so people in your organization can continue using SharePoint and OneDrive links. If you're not a Microsoft Entra admin, copy the consent link and share it with your Microsoft admin. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Learn more"
        }
      ],
      "type": 8,
      "value": "link"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.grant-consent": [
    {
      "type": 0,
      "value": "Grant Consent"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.remind-me-later": [
    {
      "type": 0,
      "value": "Remind me later"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.title": [
    {
      "type": 0,
      "value": "Action required: Grant consent for SharePoint/OneDrive"
    }
  ],
  "integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.warning-icon-label": [
    {
      "type": 0,
      "value": "Warning"
    }
  ],
  "post-office.integrations-service.integrations-service-mcp-global-sync-notification.auth-required.body.no-translate": [
    {
      "type": 0,
      "value": "The connection for *"
    },
    {
      "type": 1,
      "value": "serverName"
    },
    {
      "type": 0,
      "value": "* has expired or needs to be re-authorized."
    }
  ],
  "post-office.integrations-service.integrations-service-mcp-global-sync-notification.auth-required.reauth-button.no-translate": [
    {
      "type": 0,
      "value": "Re-authenticate"
    }
  ],
  "post-office.integrations-service.integrations-service-mcp-global-sync-notification.auth-required.runbook-link.no-translate": [
    {
      "type": 0,
      "value": "Runbook / more information"
    }
  ],
  "post-office.integrations-service.integrations-service-mcp-global-sync-notification.auth-required.title.no-translate": [
    {
      "type": 0,
      "value": ":warning: Global MCP tool sync cannot run — authentication required"
    }
  ],
  "post-office.integrations-service.integrations-service-mcp-global-sync-notification.subtitle.no-translate": [
    {
      "type": 0,
      "value": "Remote: "
    },
    {
      "type": 1,
      "value": "remoteToolCount"
    },
    {
      "type": 0,
      "value": " tools · YAML baseline: "
    },
    {
      "type": 1,
      "value": "baselineToolCount"
    },
    {
      "type": 0,
      "value": " tools"
    }
  ],
  "post-office.integrations-service.integrations-service-mcp-global-sync-notification.sync-failure.body.no-translate": [
    {
      "type": 0,
      "value": "The global MCP tool sync for *"
    },
    {
      "type": 1,
      "value": "serverName"
    },
    {
      "type": 0,
      "value": "* failed. Check the runbook for troubleshooting and retry guidance."
    }
  ],
  "post-office.integrations-service.integrations-service-mcp-global-sync-notification.sync-failure.runbook-link.no-translate": [
    {
      "type": 0,
      "value": "Runbook / more information"
    }
  ],
  "post-office.integrations-service.integrations-service-mcp-global-sync-notification.sync-failure.title.no-translate": [
    {
      "type": 0,
      "value": ":x: Global MCP tool sync failed — "
    },
    {
      "type": 1,
      "value": "serverName"
    }
  ],
  "post-office.integrations-service.integrations-service-mcp-global-sync-notification.title.no-translate": [
    {
      "type": 0,
      "value": "Global MCP tool sync — "
    },
    {
      "type": 1,
      "value": "serverName"
    }
  ]
}